export const defaultSorted = [{ dataField: "studentName", order: "asc" }];
export const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "20", value: 20 },
    { text: "30", value: 30 },
    { text: "50", value: 50 }
];
export const initialFilter = {
    filter: {
        studentName: "",
        studentEmail: "",
        quizName: ""
    },
    sortOrder: "desc", // asc||desc
    sortField: "percentage",
    pageNumber: 1,
    pageSize: 10
};